import { View } from 'react-native'
import { colors } from '@chillout/core'

const CORNER_SIZE = 28
const BORDER_WIDTH = 3
const CORNER_COLOR = '#FFFFFF'
const CORNER_OFFSET = 24
const CORNER_RADIUS = 6

interface ViewfinderProps {
  transparent?: boolean
}

export function Viewfinder({ transparent = false }: ViewfinderProps) {
  return (
    <View
      className="flex-1 overflow-hidden rounded-2xl"
      style={{ backgroundColor: transparent ? 'transparent' : colors.canvas.dark }}
    >
      <View style={{ position: 'absolute', top: CORNER_OFFSET, left: CORNER_OFFSET,
        width: CORNER_SIZE, height: CORNER_SIZE, borderTopWidth: BORDER_WIDTH,
        borderLeftWidth: BORDER_WIDTH, borderColor: CORNER_COLOR, borderTopLeftRadius: CORNER_RADIUS }} />
      <View style={{ position: 'absolute', top: CORNER_OFFSET, right: CORNER_OFFSET,
        width: CORNER_SIZE, height: CORNER_SIZE, borderTopWidth: BORDER_WIDTH,
        borderRightWidth: BORDER_WIDTH, borderColor: CORNER_COLOR, borderTopRightRadius: CORNER_RADIUS }} />
      <View style={{ position: 'absolute', bottom: CORNER_OFFSET, left: CORNER_OFFSET,
        width: CORNER_SIZE, height: CORNER_SIZE, borderBottomWidth: BORDER_WIDTH,
        borderLeftWidth: BORDER_WIDTH, borderColor: CORNER_COLOR, borderBottomLeftRadius: CORNER_RADIUS }} />
      <View style={{ position: 'absolute', bottom: CORNER_OFFSET, right: CORNER_OFFSET,
        width: CORNER_SIZE, height: CORNER_SIZE, borderBottomWidth: BORDER_WIDTH,
        borderRightWidth: BORDER_WIDTH, borderColor: CORNER_COLOR, borderBottomRightRadius: CORNER_RADIUS }} />
    </View>
  )
}
